var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-0",
    viewBox: "0 0 98.91 91.25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50,8.75a.68.68,0,0,1,.47.18L64.86,21.7a2,2,0,0,0,3.32-1.5V16.08a.71.71,0,0,1,.72-.71H81.47a.71.71,0,0,1,.71.71V36.17a2,2,0,0,0,.67,1.5L97.21,50.42a.71.71,0,0,1-.47,1.25H88a2,2,0,0,0-2,2V95.29a.71.71,0,0,1-.71.71H58.59a.71.71,0,0,1-.71-.71V74.49a2,2,0,0,0-2-2H44.12a2,2,0,0,0-2,2v20.8a.71.71,0,0,1-.71.71H14.74a.71.71,0,0,1-.71-.71V53.67a2,2,0,0,0-2-2H3.26a.71.71,0,0,1-.67-.46.73.73,0,0,1,.2-.79L49.53,8.93A.68.68,0,0,1,50,8.75m0-2a2.73,2.73,0,0,0-1.8.68L1.46,48.93a2.71,2.71,0,0,0,1.8,4.74H12V95.29A2.71,2.71,0,0,0,14.74,98H41.41a2.71,2.71,0,0,0,2.71-2.71V74.49H55.88v20.8A2.71,2.71,0,0,0,58.59,98H85.26A2.71,2.71,0,0,0,88,95.29V53.67h8.77a2.71,2.71,0,0,0,1.8-4.74L84.18,36.17V16.08a2.72,2.72,0,0,0-2.71-2.71H68.9a2.72,2.72,0,0,0-2.72,2.71V20.2L51.8,7.43A2.73,2.73,0,0,0,50,6.75Z",
    transform: "translate(-0.55 -6.75)",
    fill: "#909090"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-2",
    viewBox: "0 0 53.49 84.53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.94,9.73l9.8,9.65V88.09A2,2,0,0,1,73,90.27H27a2,2,0,0,1-1.76-2.18V11.91A2,2,0,0,1,27,9.73H64.94M33.12,87H66.88a4.11,4.11,0,0,0,4.1-4.1V49.11A4.11,4.11,0,0,0,66.88,45H33.12A4.11,4.11,0,0,0,29,49.11V82.87a4.11,4.11,0,0,0,4.1,4.1M65.76,7.73H27a4,4,0,0,0-3.76,4.18V88.09A4,4,0,0,0,27,92.27H73a4,4,0,0,0,3.76-4.18V18.55l-11-10.82ZM33.12,85a2.1,2.1,0,0,1-2.1-2.1V49.11A2.1,2.1,0,0,1,33.12,47H66.88A2.1,2.1,0,0,1,69,49.11V82.87a2.1,2.1,0,0,1-2.1,2.1Z",
    transform: "translate(-23.26 -7.73)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.53,
    y: 38.47,
    width: 1.5,
    height: 14.35,
    rx: 0.42,
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.27,
    y: 38.47,
    width: 1.5,
    height: 14.35,
    rx: 0.42,
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.85,
    y: 63.63,
    width: 1.5,
    height: 14.35,
    rx: 0.42,
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 33.67,
    y: 63.63,
    width: 1.5,
    height: 14.35,
    rx: 0.42,
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.43,63.83a.76.76,0,0,0-.49-.94,61.43,61.43,0,0,0-6-2.27A62.77,62.77,0,0,0,57.68,59a.79.79,0,0,0-.57.05.77.77,0,0,0-.37.44.76.76,0,0,0,.49.94,56.14,56.14,0,0,1,12.26,3.88A.85.85,0,0,0,70.43,63.83Z",
    transform: "translate(-23.26 -7.73)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.78,67.18",
    transform: "translate(-23.26 -7.73)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.75,67.93a.76.76,0,0,1-.49.94,60.24,60.24,0,0,1-6,2.27A61.45,61.45,0,0,1,58,72.75a.79.79,0,0,1-.57,0,.74.74,0,0,1-.37-.44.75.75,0,0,1,.48-.94,55.3,55.3,0,0,0,6.28-1.6,53.44,53.44,0,0,0,6-2.28A.86.86,0,0,1,70.75,67.93Z",
    transform: "translate(-23.26 -7.73)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.78,68a.75.75,0,0,0,.49.94,61.43,61.43,0,0,0,6,2.27,57.7,57.7,0,0,0,6.24,1.61.74.74,0,0,0,.57-.05.77.77,0,0,0,.37-.44.76.76,0,0,0-.49-.94,55.12,55.12,0,0,1-6.28-1.59,57.65,57.65,0,0,1-6-2.28A.85.85,0,0,0,30.78,68Z",
    transform: "translate(-23.26 -7.73)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.55,61.57v-.15a2.2,2.2,0,0,0-.09-.43s0-.07,0-.11a1.58,1.58,0,0,0-.4-.34l-.14-.1-1,.3a60.24,60.24,0,0,0-6,2.27.74.74,0,0,0-.49.94.86.86,0,0,0,.94.49,53.24,53.24,0,0,1,6-2.28l1.17-.36Z",
    transform: "translate(-23.26 -7.73)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.11,72.12a.74.74,0,0,0,.74.74,22.59,22.59,0,0,1,14,0,.75.75,0,0,0,0-1.49,26.18,26.18,0,0,0-14,0A.84.84,0,0,0,43.11,72.12Z",
    transform: "translate(-23.26 -7.73)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.79,59.73a.74.74,0,0,1,.75-.75,22.56,22.56,0,0,0,14,0,.73.73,0,0,1,.53.22.75.75,0,0,1-.53,1.28,26.41,26.41,0,0,1-14,0A.85.85,0,0,1,42.79,59.73Z",
    transform: "translate(-23.26 -7.73)",
    fill: "#909090"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-3-fill",
    viewBox: "0 0 65.78 77.63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.56,85.3H21.65c-1.41,0-2.53-.91-2.43-2l5.32-55.88A2.27,2.27,0,0,1,27,25.71H76.29a2.26,2.26,0,0,1,2.43,1.72L84,83.31C84.09,84.39,83,85.3,81.56,85.3Z",
    transform: "translate(-18.72 -8.17)",
    fill: "#E3264E",
    stroke: "#E3264E",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.44,
    cy: 33,
    r: 4.89,
    fill: "#fff",
    stroke: "#E3264E",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.2,
    cy: 33,
    r: 4.89,
    fill: "#fff",
    stroke: "#E3264E",
    strokeLinecap: "round",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.92,20a11.42,11.42,0,0,0-22.83.09h0V40.4a.77.77,0,0,0,.76.77.78.78,0,0,0,.77-.77V20.08s0,0,0-.08a9.89,9.89,0,0,1,19.77.08h0V40.4a.77.77,0,1,0,1.54,0V20.08S62.92,20,62.92,20Z",
    transform: "translate(-18.72 -8.17)",
    fill: "#fff",
    stroke: "#E3264E",
    strokeMiterlimit: 10
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-3",
    viewBox: "0 0 66.78 78.13"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.56,85.3H21.65c-1.41,0-2.53-.91-2.43-2l5.32-55.88A2.27,2.27,0,0,1,27,25.71H76.29a2.26,2.26,0,0,1,2.43,1.72L84,83.31C84.09,84.39,83,85.3,81.56,85.3Z",
    transform: "translate(-18.22 -8.17)",
    fill: "none",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 43.94,
    cy: 33,
    r: 4.89,
    fill: "#fff",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.7,
    cy: 33,
    r: 4.89,
    fill: "#fff",
    stroke: "#909090",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.92,20a11.42,11.42,0,0,0-22.83.09h0V40.4a.77.77,0,0,0,.76.77.78.78,0,0,0,.77-.77V20.08s0,0,0-.08a9.89,9.89,0,0,1,19.77.08h0V40.4a.77.77,0,1,0,1.54,0V20.08S62.92,20,62.92,20Z",
    transform: "translate(-18.22 -8.17)",
    fill: "#909090",
    stroke: "#909090",
    strokeMiterlimit: 10
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-1",
    viewBox: "0 0 55.57 78.53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.48,12.74a3.3,3.3,0,0,1,3.3,3.3V84a3.3,3.3,0,0,1-3.3,3.3h-45a3.3,3.3,0,0,1-3.3-3.3V16a3.3,3.3,0,0,1,3.3-3.3h45m0-2h-45a5.3,5.3,0,0,0-5.3,5.3V84a5.3,5.3,0,0,0,5.3,5.3h45a5.3,5.3,0,0,0,5.3-5.3V16a5.3,5.3,0,0,0-5.3-5.3Z",
    transform: "translate(-22.22 -10.74)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.49,22.43a6,6,0,0,0-.12-1.22,5.23,5.23,0,0,0-.88-2,5.89,5.89,0,0,0-4.85-2.6c-1.31,0-2.61,0-3.91,0-3.37,0-6.73,0-10.1,0a8.35,8.35,0,0,0-8.27,7.79v1.1A8.32,8.32,0,0,0,28.84,28a7.56,7.56,0,0,0,3.47,4.15,10.37,10.37,0,0,0,4.35,1.23c.23,0,.31-.05.31-.26a3.58,3.58,0,0,1,.21-1.3,4.93,4.93,0,0,1,3.55-3.23,5.45,5.45,0,0,1,1.56-.16c2.74,0,5.48,0,8.22,0a5.84,5.84,0,0,0,5.34-3.16,5,5,0,0,0,.53-1.48A5.33,5.33,0,0,0,56.49,22.43Z",
    transform: "translate(-22.22 -10.74)",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.82,
    y: 36.91,
    width: 42.85,
    height: 2.74,
    rx: 1.27,
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.91,
    y: 46.24,
    width: 42.85,
    height: 2.74,
    rx: 1.27,
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.91,
    y: 54.92,
    width: 29.3,
    height: 2.74,
    rx: 1.27,
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.91,
    y: 63.07,
    width: 20.81,
    height: 2.74,
    rx: 1.27,
    fill: "#909090"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-4",
    viewBox: "0 0 79.68 80.41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.37,49.67",
    transform: "translate(-9.54 -9.46)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 29.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,49.67",
    transform: "translate(-9.54 -9.46)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 37.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,84.16,63.55,60.31c.4-.48.84-1,1.28-1.64a32.19,32.19,0,0,0,4.66-9.1,30.46,30.46,0,0,0,1.35-9A30.12,30.12,0,1,0,49.6,69.43a32,32,0,0,0,7.71-3.66c.88-.57,1.65-1.13,2.28-1.62L83.5,88.06a2.75,2.75,0,0,0,3.9,0h0A2.75,2.75,0,0,0,87.4,84.16Zm-46.71-19A24.65,24.65,0,1,1,65.33,40.51,24.65,24.65,0,0,1,40.69,65.16Z",
    transform: "translate(-9.54 -9.46)",
    fill: "#fff",
    stroke: "#909090",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-1-fill",
    viewBox: "0 0 55.57 78.53"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 54.57,
    height: 77.53,
    rx: 3.43,
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.86,11.74a2.92,2.92,0,0,1,2.92,2.92V85.34a2.92,2.92,0,0,1-2.92,2.92H26.14a2.92,2.92,0,0,1-2.92-2.92V14.66a2.92,2.92,0,0,1,2.92-2.92H73.86m0-1H26.14a3.91,3.91,0,0,0-3.92,3.92V85.34a3.91,3.91,0,0,0,3.92,3.92H73.86a3.91,3.91,0,0,0,3.92-3.92V14.66a3.91,3.91,0,0,0-3.92-3.92Z",
    transform: "translate(-22.22 -10.74)",
    fill: "#E3264E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56.49,22.43a6,6,0,0,0-.12-1.22,5.23,5.23,0,0,0-.88-2,5.89,5.89,0,0,0-4.85-2.6c-1.31,0-2.61,0-3.91,0-3.37,0-6.73,0-10.1,0a8.35,8.35,0,0,0-8.27,7.79v1.1A8.32,8.32,0,0,0,28.84,28a7.56,7.56,0,0,0,3.47,4.15,10.37,10.37,0,0,0,4.35,1.23c.23,0,.31-.05.31-.26a3.58,3.58,0,0,1,.21-1.3,4.93,4.93,0,0,1,3.55-3.23,5.45,5.45,0,0,1,1.56-.16c2.74,0,5.48,0,8.22,0a5.84,5.84,0,0,0,5.34-3.16,5,5,0,0,0,.53-1.48A5.33,5.33,0,0,0,56.49,22.43Z",
    transform: "translate(-22.22 -10.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.82,
    y: 36.91,
    width: 42.85,
    height: 2.74,
    rx: 1.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.91,
    y: 46.24,
    width: 42.85,
    height: 2.74,
    rx: 1.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.91,
    y: 54.92,
    width: 29.3,
    height: 2.74,
    rx: 1.27,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.91,
    y: 63.07,
    width: 20.81,
    height: 2.74,
    rx: 1.27,
    fill: "#fff"
  })))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-2-fill",
    viewBox: "0 0 53.25 84.14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.13,91.19a3.11,3.11,0,0,1-2.88-3.28V12.08a3.11,3.11,0,0,1,2.88-3.29h38.2L75.72,19V87.89a3.09,3.09,0,0,1-2.87,3.28Zm6.07-45a3,3,0,0,0-3,3h0v33.6a3,3,0,0,0,3,3H66.8a3,3,0,0,0,3-3V49.11a3,3,0,0,0-3-3Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65,9.69l9.89,9.74V87.91a2.21,2.21,0,0,1-2,2.4H27.12a2.22,2.22,0,0,1-2-2.4V12.09a2.22,2.22,0,0,1,2-2.4H65M33.19,86.56H66.8a3.86,3.86,0,0,0,3.85-3.85V49.11a3.85,3.85,0,0,0-3.85-3.85H33.19a3.85,3.85,0,0,0-3.85,3.85v33.6a3.86,3.86,0,0,0,3.85,3.85M65.69,7.93H27.13a4,4,0,0,0-3.75,4.16V87.91a4,4,0,0,0,3.75,4.16H72.87a4,4,0,0,0,3.75-4.16V18.69ZM33.19,84.81a2.1,2.1,0,0,1-2.09-2.1V49.11A2.1,2.1,0,0,1,33.19,47H66.8a2.1,2.1,0,0,1,2.09,2.1h0v33.6a2.1,2.1,0,0,1-2.09,2.1Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.56,46.23h0a.75.75,0,0,1,.75.74V59.76a.75.75,0,0,1-.75.75h0a.74.74,0,0,1-.74-.75V47A.74.74,0,0,1,43.56,46.23Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.24,46.23h0A.74.74,0,0,1,58,47V59.76a.74.74,0,0,1-.74.75h0a.75.75,0,0,1-.75-.75V47A.75.75,0,0,1,57.24,46.23Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.88,71.27h0a.74.74,0,0,1,.74.74v12.8a.74.74,0,0,1-.74.74h0a.75.75,0,0,1-.75-.74V72A.75.75,0,0,1,43.88,71.27Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.64,71.27h0a.74.74,0,0,1,.74.74v12.8a.74.74,0,0,1-.74.74h0a.74.74,0,0,1-.74-.74V72A.74.74,0,0,1,57.64,71.27Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.33,63.77a.75.75,0,0,0-.49-.93A59.19,59.19,0,0,0,57.65,59a.71.71,0,0,0-.57.05.73.73,0,0,0-.32,1,.77.77,0,0,0,.44.37,54.89,54.89,0,0,1,12.19,3.86A.86.86,0,0,0,70.33,63.77Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.69,67.1",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.65,67.85a.75.75,0,0,1-.48.93A59.47,59.47,0,0,1,58,72.64a.75.75,0,0,1-.57,0,.74.74,0,0,1-.32-1,.77.77,0,0,1,.44-.37,55,55,0,0,0,12.2-3.86A.85.85,0,0,1,70.65,67.85Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.87,67.89a.74.74,0,0,0,.48.93h0a59.8,59.8,0,0,0,12.19,3.86.8.8,0,0,0,.57,0,.75.75,0,0,0,.33-1,.73.73,0,0,0-.44-.37,55.53,55.53,0,0,1-12.2-3.87A.86.86,0,0,0,30.87,67.89Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6,61.52v-.15a2.07,2.07,0,0,0-.1-.43.49.49,0,0,0,0-.11,1.59,1.59,0,0,0-.39-.34.71.71,0,0,1-.14-.1l-1,.3a61.81,61.81,0,0,0-6,2.26.75.75,0,0,0-.48.93.83.83,0,0,0,.93.48,56.77,56.77,0,0,1,5.94-2.27l1.16-.37A1,1,0,0,0,38.6,61.52Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.13,72a.76.76,0,0,0,.75.75h0a22.42,22.42,0,0,1,14,0,.74.74,0,0,0,.52-.22.73.73,0,0,0,0-1.05.75.75,0,0,0-.53-.22,26.12,26.12,0,0,0-14,0A.85.85,0,0,0,43.13,72Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.82,59.68a.74.74,0,0,1,.74-.74h0a22.56,22.56,0,0,0,14,0,.75.75,0,1,1,0,1.49,26.12,26.12,0,0,1-14,0A.85.85,0,0,1,42.82,59.68Z",
    transform: "translate(-23.37 -7.93)",
    fill: "#E3264E"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-0-fill",
    viewBox: "0 0 98.91 91.25"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M61.8,92.08V71.78a3.21,3.21,0,0,0-3.21-3.21H41.41a3.21,3.21,0,0,0-3.21,3.21v20.3H18V51a3.21,3.21,0,0,0-3.21-3.21h-3L50,13.76,66.76,28.64a3.24,3.24,0,0,0,2.14.81,3.28,3.28,0,0,0,1.31-.28,3.21,3.21,0,0,0,1.9-2.93V19.3h6.14V37.39a3.25,3.25,0,0,0,1.08,2.41l9,7.94h-3A3.21,3.21,0,0,0,82.05,51V92.08Z",
    transform: "translate(-0.55 -6.75)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,14.43,66.43,29A3.69,3.69,0,0,0,68.9,30a3.62,3.62,0,0,0,1.52-.33,3.72,3.72,0,0,0,2.19-3.38V19.8h5.14V37.39A3.73,3.73,0,0,0,79,40.17l8,7.07H85.26A3.72,3.72,0,0,0,81.55,51V91.58H62.3V71.78a3.71,3.71,0,0,0-3.71-3.71H41.41a3.71,3.71,0,0,0-3.71,3.71v19.8H18.45V51a3.72,3.72,0,0,0-3.71-3.71H13L50,14.43m0-1.34L10.4,48.24h4.34A2.71,2.71,0,0,1,17.45,51V92.58H38.7V71.78a2.71,2.71,0,0,1,2.71-2.71H58.59a2.71,2.71,0,0,1,2.71,2.71v20.8H82.55V51a2.71,2.71,0,0,1,2.71-2.71H89.6l-9.94-8.82a2.7,2.7,0,0,1-.91-2V18.8H71.61v7.44a2.71,2.71,0,0,1-4.51,2L50,13.09Z",
    transform: "translate(-0.55 -6.75)",
    fill: "#E3264E"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.59,97.5a2.21,2.21,0,0,1-2.21-2.21V74.49a.51.51,0,0,0-.5-.5H44.12a.51.51,0,0,0-.5.5v20.8a2.21,2.21,0,0,1-2.21,2.21H14.74a2.21,2.21,0,0,1-2.21-2.21V53.67a.5.5,0,0,0-.5-.5H3.26A2.21,2.21,0,0,1,1.79,49.3L48.53,7.81a2.21,2.21,0,0,1,2.94,0L65.85,20.57a.48.48,0,0,0,.33.13.52.52,0,0,0,.21,0,.5.5,0,0,0,.29-.46V16.08a2.22,2.22,0,0,1,2.22-2.21H81.47a2.21,2.21,0,0,1,2.21,2.21V36.17a.5.5,0,0,0,.17.38L98.21,49.3a2.21,2.21,0,0,1-1.47,3.87H88a.5.5,0,0,0-.5.5V95.29a2.21,2.21,0,0,1-2.21,2.21Z",
    transform: "translate(-0.55 -6.75)",
    fill: "#E3264E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,7.75a1.72,1.72,0,0,1,1.14.43L65.52,21a1,1,0,0,0,.66.25,1,1,0,0,0,.41-.09,1,1,0,0,0,.59-.91V16.08a1.72,1.72,0,0,1,1.72-1.71H81.47a1.72,1.72,0,0,1,1.71,1.71V36.17a1,1,0,0,0,.33.75L97.88,49.67a1.72,1.72,0,0,1-1.14,3H88a1,1,0,0,0-1,1V95.29A1.71,1.71,0,0,1,85.26,97H58.59a1.72,1.72,0,0,1-1.71-1.71V74.49a1,1,0,0,0-1-1H44.12a1,1,0,0,0-1,1v20.8A1.72,1.72,0,0,1,41.41,97H14.74A1.71,1.71,0,0,1,13,95.29V53.67a1,1,0,0,0-1-1H3.26a1.72,1.72,0,0,1-1.14-3L48.86,8.18A1.72,1.72,0,0,1,50,7.75m0-1a2.73,2.73,0,0,0-1.8.68L1.46,48.93a2.71,2.71,0,0,0,1.8,4.74H12V95.29A2.71,2.71,0,0,0,14.74,98H41.41a2.71,2.71,0,0,0,2.71-2.71V74.49H55.88v20.8A2.71,2.71,0,0,0,58.59,98H85.26A2.71,2.71,0,0,0,88,95.29V53.67h8.77a2.71,2.71,0,0,0,1.8-4.74L84.18,36.17V16.08a2.72,2.72,0,0,0-2.71-2.71H68.9a2.72,2.72,0,0,0-2.72,2.71V20.2L51.8,7.43A2.73,2.73,0,0,0,50,6.75Z",
    transform: "translate(-0.55 -6.75)",
    fill: "#E3264E"
  })))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-menu-4-fill",
    viewBox: "0 0 78.68 79.41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.37,49.67",
    transform: "translate(-10.04 -9.96)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 29.11
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.37,49.67",
    transform: "translate(-10.04 -9.96)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 37.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4,84.16,63.55,60.31c.4-.48.84-1,1.28-1.64a32.19,32.19,0,0,0,4.66-9.1,30.46,30.46,0,0,0,1.35-9A30.12,30.12,0,1,0,49.6,69.43a32,32,0,0,0,7.71-3.66c.88-.57,1.65-1.13,2.28-1.62L83.5,88.06a2.75,2.75,0,0,0,3.9,0h0A2.75,2.75,0,0,0,87.4,84.16Zm-46.71-19A24.65,24.65,0,1,1,65.33,40.51,24.65,24.65,0,0,1,40.69,65.16Z",
    transform: "translate(-10.04 -9.96)",
    fill: "#E3264E",
    stroke: "#E3264E",
    strokeMiterlimit: 10
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcons);
export default __webpack_public_path__ + "static/media/MenuIcons.d541233c05e8e7368d97f074ed3f8649.svg";
export { ForwardRef as ReactComponent };